import {createApp} from 'vue';
import App from './App.vue';

import {register} from 'swiper/element/bundle';
register();

import 'swiper/css';
import './scss/_index.scss';
import store from './store';
import router from './router';

const app = createApp(App);

app.use(store);
app.use(router);
app.mount('#app');
